import { DialogFormFieldContainer } from '@/common/dialog/DialogFormFieldContainer';
import { Form } from '@/common/form/Form';
import { EnumSelect } from '@/common/form/formFields/EnumSelect';
import { TextFormField } from '@/common/form/formFields/TextFormField';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { useEffect, useRef, useState } from 'react';

export const McdDispDialog = ({ data, closeDialog }) => {
  /* Medicaid Dispute Type Enumeration */
  const rsrc = useRsrc();
  const [mcdDispTypes, setMcdDispTypes] = useState();
  useEffect(() => {
    rsrc.data('sc', 'ENUM_DATA_PLUGIN', { enumCode: 'MCD_DISP_TYPE' }).then((res) => {
      setMcdDispTypes(res);
    });
  }, []);

  /* Submission action */
  const formRef = useRef();
  const submit = () => {
    const formValues = formRef.current.formValues;
    const reqParam = {
      mcdDispType: formValues.mcdDispType,
      comment: formValues.comment,
      mcdUtilLineIds: data.utilLineIds,
      partition: data.partition,
    };

    rsrc.store('sc', 'MCD_DISP_FROM_UTIL_LINE_STORE_PLUGIN', reqParam);
    closeDialog();
  };

  if (!mcdDispTypes) return <></>;

  return (
    <Dialog onClose={() => closeDialog()} open fullWidth>
      {/* Title */}
      <DialogTitle>Dispute CLD Data</DialogTitle>

      <DialogContent>
        {/* Plugin field definition form */}
        <Form ref={formRef}>
          <DialogFormFieldContainer>
            <EnumSelect
              fieldDef={{ field: 'mcdDispType', displayName: 'Dispute Type', type: 'ENUM', values: mcdDispTypes }}
              shouldDisplayCode={true}
            />
            <TextFormField
              fieldDef={{ field: 'comment', displayName: 'Comment', type: 'NONE', defaultValue: data.valCodes }}
            />
          </DialogFormFieldContainer>
        </Form>
      </DialogContent>

      {/* Bottom Buttons */}
      <DialogActions>
        <Button onClick={() => closeDialog()}>Cancel</Button>
        <Button onClick={submit} data-test-id="disp-dialog-submit">
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
};
